import { render, staticRenderFns } from "./AccountDropdownMenu.vue?vue&type=template&id=86489f34&"
import script from "./AccountDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./AccountDropdownMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports